var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 58,
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.448725 5.94926C0.477117 2.65585 3.15497 0.000982298 6.4485 0.000982064L83.6562 0.000976562C77.0197 21.3092 66.2287 41.0095 52.097 58.001L6.05195 58.001C2.71802 58.001 0.0234305 55.2831 0.0521704 51.9493L0.448725 5.94926Z",
    fill: "#CA3131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2037 0.000379959L6.00003 2.95292e-05C2.68631 1.32207e-05 3.15214e-06 2.68631 3.15214e-06 6.00003V52.001C3.15214e-06 55.3147 2.68629 58.001 6 58.001H46.4998C60.3028 41.0025 70.8015 21.1822 77.2037 0.000379959Z",
    fill: "#EB4848"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9994 15.5H20H44C44.6912 15.5 45.2709 15.7405 45.7659 16.2356C46.261 16.7306 46.5008 17.3096 46.5 17.9994V18V36C46.5 36.6912 46.2595 37.2709 45.7644 37.7659C45.2694 38.261 44.6904 38.5008 44.0006 38.5H44H23H22.7929L22.6464 38.6464L17.5 43.7929V18C17.5 17.3088 17.7405 16.7291 18.2356 16.2341C18.7306 15.739 19.3096 15.4992 19.9994 15.5ZM20 15H44C44.825 15 45.5315 15.294 46.1195 15.882C46.7075 16.47 47.001 17.176 47 18V36C47 36.825 46.706 37.5315 46.118 38.1195C45.53 38.7075 44.824 39.001 44 39L20 15Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7861 22.5718L36.2143 31",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2148 22.5718L27.7867 31",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToast);
export default __webpack_public_path__ + "static/media/errorToast.e83c5ef1cfa37912b316d6ebe46ae834.svg";
export { ForwardRef as ReactComponent };